import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';

export interface RAGListResponse {
  rags: Array<{ name: string; status: string; isDefault?: boolean }>;
  default: string;
  loadedCount: number;
}

@Injectable({ providedIn: 'root' })
export class KngRagService {
  private readonly ragListSubject = new BehaviorSubject<RAGListResponse | null>(null);
  readonly ragList$ = this.ragListSubject.asObservable();

  constructor(private $http: HttpClient) {}

  getRAGList(): Observable<RAGListResponse> {
    return this.$http.get<RAGListResponse>('/api/rag', { withCredentials: true }).pipe(
      tap((rag) => this.ragListSubject.next(rag)),
    );
  }
}
